<template>
  <div>
    <b-row class="justify-content-center">
      <b-col cols="12" sm="6">
        <label>Nom d'utilisateur :</label>
        <ValidationProvider
          ref="vee-username"
          v-slot="{ errors, classes }"
          :name="'username'"
          rules="required"
          mode="passive"
        >
          <b-input
            type="text"
            autofocus
            :value="object.username"
            @input="$emit('updateObject', 'username', $event)"
          />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
        <b-row class="my-2">
          <b-col cols="auto" class="pr-0">
            <font-awesome-icon icon="info-circle" />
          </b-col>
          <!-- ???: FIXME: .. -->
          <b-col class="pl-2"> Lorem ipsum dolor sit amet, consectetur adipiscing elit </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
